export class Automation {
    automationGroupId: string
    parentAutomationId?: string
    parentRule?: string
    createdAt: Date
    updatedAt?: Date
    automationId: string
    act: string
    tagId?: string
    creativeId?: string
    channelId?: string
    boardId?: string
    listId?: string
    boardStatus?: string
    message?: string
    userId?: string
    status: number
    delay: number
    fbId?: string
    fbToken?: string
    fbAdsAccount?: string
    fbAudience?: string
    contacted: any[]
    nextRun?: Date
    expirationInHours: number
}
